<template>
  <v-data-table
    :loading="loading"
    :headers="headers"
    :items="items"
    :server-items-length="meta.total"
    :footer-props="footerProps"
    :options="options"
    :page="page"
    :items-per-page="itemsPerPage"
    :sort-by="sortBy"
    :sort-desc="sortDesc"
    :multi-sort="multiSort"
    v-on="listeners"
  >
    <template v-slot:item.status="{ item }">
      <v-chip :color="item.status_color" text-color="white">
        {{ item.status }}
      </v-chip>
    </template>

    <template v-slot:item.action="{ item }">
      <action-slot-component
        :item="item"
        route-name="building_complexes.show"
        open-in-new-window
        :route-params="{ id: item.id }"
        @show="$emit('show', item)"
      />
    </template>
  </v-data-table>
</template>

<script>
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import listItems from '@/modules/_global/mixins/list-items';
import ActionSlotComponent from '@/modules/_global/_components/ActionSlotComponent.vue';

export default {
  name: 'BuildingComplexesList',
  components: { ActionSlotComponent },

  mixins: [i18nRefreshData, listItems],

  data: () => ({}),

  computed: {
    headers() {
      return [
        {
          text: this.$t('ITEM.ID'),
          align: 'left',
          sortable: true,
          value: 'id'
        },
        {
          text: this.$t('ITEM.NAME'),
          value: 'name'
        },
        {
          text: this.$t('PROFILE.ZIP'),
          value: 'zip'
        },
        {
          text: this.$t('PROFILE.CITY'),
          value: 'city'
        },
        {
          text: this.$t('ITEM.TYPE'),
          value: 'type'
        },
        {
          text: this.$t('BUILDING_COMPLEXES.BUSINESS_CUSTOMER_NAME'),
          value: 'business_customer'
        },
        {
          text: this.$t('BUILDING_COMPLEXES.MANAGEMENT_COMPANY'),
          value: 'management_company'
        },
        {
          text: this.$t('BUILDING_COMPLEXES.CONCIERGE'),
          value: 'concierge'
        },
        {
          text: this.$t('PROFILE.STATUS'),
          value: 'status'
        },
        {
          text: this.$t('DATA_TABLE.ACTIONS'),
          value: 'action',
          align: 'center'
        }
      ];
    }
  },

  methods: {}
};
</script>
